import { FeedInfo } from '@app/models/feed-source-info';

export interface RssFeeds {
  feedLinksAndTagName: Array<FeedInfo>;

  amountToShowPerLoad: RssFeedAmount;
}

export enum RssFeedAmount {
  Small = 0,
  Medium = 1
}
